export default {
  lang: {
    selectAll: 'Sélectionne toute la page',
    selected: 'Sélectionner',
    term: 'Article',
    deselect: 'Annuler la sélection',
  },
};
